import React, { useState } from 'react';
import { CopyIcon } from '@rsos/assets/icons';
import copyToClipboard from '@rsos/utils/copyToClipboard';
import {
  HoveredButton,
  HoveredContainer,
  ButtonText,
} from './HoveredButtons.styles';
import { handleSetIsCopiedTimer } from './helpers';

const HoveredCopyButton = ({
  handleClick = () => {},
  copyableText = '',
  top = 'auto',
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const onClick = () => {
    handleClick();
    copyToClipboard(copyableText);
    handleSetIsCopiedTimer(setIsCopied);
  };

  return (
    <HoveredContainer copied={isCopied} top={top}>
      <HoveredButton
        onClick={onClick}
        copied={isCopied}
        data-testid="hoveredBtn"
      >
        <CopyIcon height={12} width={12} />
        <ButtonText>{isCopied ? 'COPIED' : 'COPY'}</ButtonText>
      </HoveredButton>
    </HoveredContainer>
  );
};

export default HoveredCopyButton;
